import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["dealCurrencyCode", "paymentLinks", "hiddenIds", "placeholder", "noResultsText"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UISelect from 'UIComponents/input/UISelect';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UILink from 'UIComponents/link/UILink';
import Raven from 'raven-js';
import FormattedPrice from './FormattedPrice';
import RecurringMessage from './RecurringMessage';
import { getPaymentLinksUrl } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PaymentLinkHeader({
  paymentLink: {
    id,
    name,
    subtotals
  }
}) {
  const {
    firstPaymentTotal,
    currencyCode,
    recurringSubtotals
  } = subtotals || {};
  const hasRecurringSubtotal = recurringSubtotals && recurringSubtotals[0];
  return /*#__PURE__*/_jsx(UITruncateString, {
    title: name,
    "data-selenium": `payment-value-${id}`,
    "data-test-id": "payment-link-header",
    useFlex: true,
    fixedChildren: /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      style: {
        width: 'auto'
      },
      children: [/*#__PURE__*/_jsx("span", {
        className: "m-x-1",
        children: "|"
      }), /*#__PURE__*/_jsx(FormattedPrice, {
        currencyCode: currencyCode,
        price: firstPaymentTotal
      }), hasRecurringSubtotal && /*#__PURE__*/_jsx(Small, {
        className: "m-left-1",
        use: "help",
        children: /*#__PURE__*/_jsx(UITruncateString, {
          maxWidth: 125,
          children: /*#__PURE__*/_jsx(RecurringMessage, {
            currencyCode: currencyCode,
            recurringSubtotals: recurringSubtotals
          })
        })
      })]
    }),
    children: name
  });
}
function PaymentLinkOption({
  option,
  children
}) {
  const {
    paymentLink
  } = option;
  if (!paymentLink) return children;
  return /*#__PURE__*/_jsx(PaymentLinkItem, {
    paymentLink: paymentLink
  });
}
export function PaymentLinkItem({
  paymentLink
}) {
  const {
    lineItems = []
  } = paymentLink;
  const products = lineItems.map(item => item.name).join(', ');
  return /*#__PURE__*/_jsxs("div", {
    className: "m-x-5 p-y-2",
    "data-selenium": `payment-option-${paymentLink.id}`,
    children: [/*#__PURE__*/_jsx(PaymentLinkHeader, {
      paymentLink: paymentLink
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(UITruncateString, {
        tooltip: products,
        children: /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: products
        })
      })
    })]
  });
}
function ValueComponent({
  option,
  children
}) {
  const {
    paymentLink
  } = option;
  // handles the case where the option is the placeholder, which is not a payment link
  if (!paymentLink) return children;
  return /*#__PURE__*/_jsx(PaymentLinkHeader, {
    paymentLink: paymentLink
  });
}
function PaymentLinkSelect(_ref) {
  let {
      dealCurrencyCode,
      paymentLinks,
      hiddenIds,
      placeholder,
      noResultsText
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  let options = [];
  const ON = 'ON';
  try {
    options = paymentLinks.filter(paymentLink => {
      if (dealCurrencyCode) {
        return paymentLink.state === ON && paymentLink.currency === dealCurrencyCode;
      }
      return paymentLink.state === ON;
    }).map(paymentLink => {
      return {
        value: paymentLink.id,
        text: paymentLink.name,
        paymentLink
      };
    });
    if (hiddenIds && hiddenIds.length) {
      options = options.filter(option => !hiddenIds.includes(option.value));
    }
  } catch (error) {
    // TODO add error state handling
    Raven.captureMessage('Bad paymentLinks prop, not in right format', {
      extra: {
        paymentLinks
      }
    });
  }
  return /*#__PURE__*/_jsx(UISelect, Object.assign({
    "data-selenium": "payment-link-select",
    options: options,
    filterOptions: filterOptions,
    optionComponent: PaymentLinkOption,
    valueComponent: ValueComponent,
    noResultsText: noResultsText || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "paymentLinkSelect.noResults"
    }),
    placeholder: placeholder || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "paymentLinkSelect.placeholder"
    }),
    minimumSearchCount: 0,
    dropdownFooter: /*#__PURE__*/_jsx(UILink, {
      href: getPaymentLinksUrl(),
      external: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "paymentLinkSelect.goToPaymentLinks"
      })
    })
  }, props));
}

// When search term is entered, look for matching payment link name or line item name
function filterOptions(options, rawInput) {
  const input = rawInput.toLowerCase();
  return options.filter(option => {
    const {
      text,
      paymentLink
    } = option;
    if (text && text.toLowerCase().includes(input)) return true;
    if (paymentLink && Array.isArray(paymentLink.lineItems)) {
      return paymentLink.lineItems.some(item => item.name && item.name.toLowerCase().includes(input));
    }
    return false;
  });
}
export default PaymentLinkSelect;